// getManager.js
import axiosInstance from 'services/axiosMiddleware';

export async function getManager() {
  try {
    const response = await axiosInstance.get('users/managers');
    return response.data.response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}